
import React, { forwardRef, useImperativeHandle} from "react"
import { Box, IconButton, Popover } from "@mui/material";
const PopoverDefault = forwardRef(({ children, icon, onOpen, onClose, anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
}, transformOrigin = {
  vertical: 'top',
  horizontal: 'center',
} }, ref) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  useImperativeHandle(ref, () => {
    return {
      close: () => {
        setAnchorEl(null)
      }
    }
  })
  return (
    <Box>
      <IconButton onClick={(e) => {
        setAnchorEl(e.currentTarget)
        if(onOpen){
          onOpen()
        }
      }} sx={{ p: 0 }}>
        {icon}
      </IconButton>
      <Popover open={open}
        anchorEl={anchorEl}
        onClose={() => {
          if (onClose) onClose()
          setAnchorEl(null)
        }}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}>
        {children}
      </Popover>
    </Box>
  )
}, [])

export default React.memo(PopoverDefault)